import { render } from "./SpinnerLoader.vue?vue&type=template&id=73e2f339&scoped=true&ts=true"
import script from "./SpinnerLoader.vue?vue&type=script&lang=ts"
export * from "./SpinnerLoader.vue?vue&type=script&lang=ts"

import "./SpinnerLoader.vue?vue&type=style&index=0&id=73e2f339&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73e2f339"]])

export default __exports__